import React, { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";

import { AppStore } from "../../stores/AppStore";

const isExpired = (token: string): boolean => {
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    return !!exp && exp * 1000 < Date.now();
  } catch {
    // Malformed token — treat as expired.
    return true;
  }
};

/** Route guard for the admin area: redirects to the login page when there is no valid session. */
const RequireAuth: FC<{ children: ReactNode }> = observer(({ children }) => {
  const store = AppStore.getInstance();

  if (!store.accessToken || isExpired(store.accessToken)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
});

export default RequireAuth;
